import { Time } from '@angular/common';

export class StudentSession {
  id: number
  sessionItem: SessionItem
  learningObjective1: string;
  learningObjective2: string;
  learningObjective3: string;
  learningObjective1Grade: string;
  learningObjective2Grade: string;
  learningObjective3Grade: string;

  learningComment: string;
  engagementObjective1: string;
  engagementObjective2: string;
  engagementObjective3: string;

  engagementObjective1Grade: string;
  engagementObjective2Grade: string;
  engagementObjective3Grade: string;

  engagementComment: string;
}


export class SessionItem {
  placementId: number;
  startDate: Date;
  startTime: Time;
  endTime: Time;
  sessionType: string;
  attendance: string;
  subject: string;
}

export class SessionGroup {
  header: string;
  subject: string
  placementID: number;
  /**
   * Orbit BookingSessions.Id — the exact session this row addresses. The row click navigates on this
   * (alongside placementID) so the report is bound to one session, not just a date (SessionIdentityGrain.md).
   */
  sessionId: number;
  tutorId: number;
  startDate: Date;
  endDate: Date;
  tutorName: string
  clientReferrer: string
  client: string
  clientId: number;
  student: string
  attendance: string
  sessionDate: Date;
  startTime: any;
  endTime: any;
  tutorFullName: string
  aPorSP: string
  tutorMobile: string
  tutorLandLine: string
  studentName: string
  tutorEmail: string
  reportsRequired: boolean;
  isGroupPlacement: boolean;
  groupSize: number;
  groupName: string;
  referrerId: number;
  // Orbit OPC DeliveryMode ('Online'/'In person'), per session. Rendered as the same Delivery pill
  // the placement search uses.
  deliveryMode: string;
  // New / Saved / Submitted / Approved / Rejected — the same names the view-sessions calendar renders,
  // so a rejected report reads red on the sessions tile too (app-session-status-pill).
  status: string;
}

export class SessionTileParams {
  sessionHeader: string;
  startDate: Date;
  endDate: Date;
  excludeToday: boolean = false;
  mode: boolean = true;
  sessionNodata?: string;
  isSearch?: boolean = false;
  user?: any[] = [];
  preLoadedData?: any[] = null;
  /** Tutor landing only: row click goes straight to add-session-v2 instead of /tutorreports. */
  navigateToAddSession?: boolean = false;
}

export class SubmissionParams {
  client: string = null;
  clientReferrer: string = null;
  endDate: Date = null;
  startDate: Date = null;
  tutor: string = null
  onSearched: boolean = false;
  student: string = null;
  task: string = null;
  user: any = {};
  userEmail: string = null;
  userRelationshipId: number = null;
  selectAll: boolean = false;
  currDate: Date = null;
  /** Brands to restrict to; empty or absent means every brand the user may see. */
  companyIds?: number[];
  /** Actions only: placements the signed-in user owns as consultant. Sent only when filters.actions is on. */
  assignedToMe?: boolean;
  /** Actions only: 'open' (default) | 'done' | 'all'. Sent only when filters.actions is on. */
  status?: 'open' | 'done' | 'all';
  /** Actions only: open actions older than the overdue threshold. Sent only when filters.actions is on. */
  overdue?: boolean;
  /** Missing submissions only: register / report / progress / ilp. Sent only when filters.missing-submissions is on. */
  missingItemTypes?: string[];
  /** Missing submissions only: '1-2' | '3-7' | '7+'. */
  daysOverdue?: string;
  /** Missing submissions only: owning consultant ids (Orbit consultant, dbo.Placements.CoordinatorId). */
  consultantIds?: number[];
}


export class SessionSelectedDateInfo {
  startDate: Date;
  startTime: string = "";
  endTime: string = "";

  constructor() {}
}